import { CREDITS } from "@card-data/credits";
import { schemas } from "@card-data/generated/api.client";
import { WEIGHTS } from "@card-data/weights";

import { DISCONTINUED_OFFERS } from "../placeholder-offers";
import { CreditCardInput } from "../types";

export const BANK_OF_AMERICA_CARDS: Array<CreditCardInput> = [
  {
    cardId: "f2d769efdbe2b9d8734787bc24297be6",
    name: "Air France KLM",
    issuer: schemas.IssuersEnum.enum.BANK_OF_AMERICA,
    network: schemas.NetworksEnum.enum.MASTERCARD,
    currency: schemas.CurrenciesEnum.enum.FLYING_BLUE,
    isBusiness: false,
    annualFee: 89,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1,
    url: "https://wwws.airfrance.us/information/flyingblue/carte-bancaire-partenaire",
    imageUrl: "/images/bankofamerica/air-france-klm.webp",
    credits: [],
    offers: [
      {
        amount: [{ amount: 100_000 }],
        spend: 7500,
        days: 180,
        credits: [],
        details:
          "70k after $3k/90d + 30k after additional $4.5k, both within 180 days. Also includes 100 XP.",
      },
      {
        amount: [{ amount: 70_000 }],
        spend: 3000,
        days: 90,
        credits: [],
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 50_000 }],
        spend: 2000,
        days: 90,
        credits: [],
        expiration: "2026-04-18",
      },
      {
        amount: [{ amount: 70_000 }],
        spend: 3000,
        days: 90,
        credits: [],
      },
      {
        amount: [{ amount: 70_000 }, { amount: 100, currency: "USD" }],
        spend: 2000,
        days: 90,
        credits: [],
      },
    ],
  },
  {
    cardId: "f2461735a56702c428c209486e2f9e55",
    name: "Customized Cash Rewards",
    issuer: schemas.IssuersEnum.enum.BANK_OF_AMERICA,
    network: schemas.NetworksEnum.enum.VISA,
    currency: schemas.CurrenciesEnum.enum.USD,
    isBusiness: false,
    annualFee: 0,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1,
    url: "https://www.bankofamerica.com/credit-cards/products/cash-back-credit-card/",
    imageUrl: "/images/bankofamerica/customized-cash-rewards.jpg",
    credits: [],
    offers: [
      {
        amount: [{ amount: 200 }],
        spend: 1000,
        days: 90,
        credits: [],
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 300 }],
        spend: 2000,
        days: 90,
        credits: [],
      },
    ],
  },
  {
    cardId: "eb8bc1a6f86dc471aa0deeca619fbf59",
    name: "Premium Rewards",
    issuer: schemas.IssuersEnum.enum.BANK_OF_AMERICA,
    network: schemas.NetworksEnum.enum.VISA,
    currency: schemas.CurrenciesEnum.enum.BANK_OF_AMERICA,
    isBusiness: false,
    annualFee: 95,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1,
    url: "https://www.bankofamerica.com/credit-cards/products/premium-rewards-credit-card/",
    imageUrl: "/images/bankofamerica/premium-rewards.png",
    credits: [],
    offers: [
      {
        amount: [{ amount: 60_000 }],
        spend: 4000,
        days: 90,
        credits: [],
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 60_000 }],
        spend: 5000,
        days: 90,
        credits: [],
      },
    ],
  },
  {
    cardId: "20594480e9f5656485a12e13389f60c7",
    name: "Premium Rewards Elite",
    issuer: schemas.IssuersEnum.enum.BANK_OF_AMERICA,
    network: schemas.NetworksEnum.enum.VISA,
    currency: schemas.CurrenciesEnum.enum.BANK_OF_AMERICA,
    isBusiness: false,
    annualFee: 550,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1,
    url: "https://www.bankofamerica.com/credit-cards/products/premium-rewards-elite-credit-card/",
    imageUrl: "/images/bankofamerica/premium-rewards-elite.png",
    credits: [
      CREDITS.PRECHECK_OR_SIMILAR,
      {
        value: 300,
        description: "Incidental Airline Statement Credits",
        weight: 0.3,
      },
      {
        value: 150,
        description:
          "Annaul $150 streaming, delivery, fitness, and transit credit",
        weight: 0.8,
      },
    ],
    offers: [
      {
        amount: [{ amount: 75_000 }],
        spend: 5000,
        days: 90,
        credits: [],
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 75_000 }],
        spend: 5000,
        days: 90,
        credits: [],
      },
    ],
  },
  {
    cardId: "fecfaab2c32f3edd5d97eafd8f3f19d6",
    name: "Travel Rewards",
    issuer: schemas.IssuersEnum.enum.BANK_OF_AMERICA,
    network: schemas.NetworksEnum.enum.VISA,
    currency: schemas.CurrenciesEnum.enum.BANK_OF_AMERICA,
    isBusiness: false,
    annualFee: 0,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1.5,
    url: "https://www.bankofamerica.com/credit-cards/products/travel-rewards-credit-card/",
    imageUrl: "/images/bankofamerica/travel-rewards.png",
    credits: [],
    offers: [
      {
        amount: [{ amount: 25_000 }],
        spend: 1000,
        days: 90,
        credits: [],
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 25_000 }],
        spend: 1000,
        days: 90,
        credits: [],
      },
    ],
  },
  {
    cardId: "98db04658d4deee69293bd67bd2fd341",
    name: "Unlimited Cash Rewards",
    issuer: schemas.IssuersEnum.enum.BANK_OF_AMERICA,
    network: schemas.NetworksEnum.enum.VISA,
    currency: schemas.CurrenciesEnum.enum.USD,
    isBusiness: false,
    annualFee: 0,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1.5,
    url: "https://www.bankofamerica.com/credit-cards/products/unlimited-cash-back-credit-card/",
    imageUrl: "/images/bankofamerica/unlimited-cash-rewards.png",
    credits: [],
    offers: [
      {
        amount: [{ amount: 200 }],
        spend: 1000,
        days: 90,
        credits: [],
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 200 }],
        spend: 1000,
        days: 90,
        credits: [],
      },
    ],
  },
  {
    cardId: "4f6d71dd4d06ff960cae0990b5efda21",
    name: "Business Advantage Customized Cash",
    issuer: schemas.IssuersEnum.enum.BANK_OF_AMERICA,
    network: schemas.NetworksEnum.enum.MASTERCARD,
    currency: schemas.CurrenciesEnum.enum.USD,
    isBusiness: true,
    annualFee: 0,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1.5,
    url: "https://www.bankofamerica.com/smallbusiness/credit-cards/products/cash-rewards-business-credit-card",
    imageUrl: "/images/bankofamerica/business-advantage-customized-cash.jpg",
    credits: [],
    offers: [
      {
        amount: [{ amount: 500 }],
        spend: 5000,
        days: 90,
        credits: [],
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 300 }],
        spend: 3000,
        days: 90,
        credits: [],
        expiration: "2026-03-21",
      },
      {
        amount: [{ amount: 300 }],
        spend: 1000,
        days: 90,
        credits: [],
      },
    ],
  },
  {
    cardId: "a99aa675065459b90144275ac18d9ab1",
    name: "Business Advantage Unlimited Cash",
    issuer: schemas.IssuersEnum.enum.BANK_OF_AMERICA,
    network: schemas.NetworksEnum.enum.MASTERCARD,
    currency: schemas.CurrenciesEnum.enum.USD,
    isBusiness: true,
    annualFee: 0,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1.5,
    url: "https://www.bankofamerica.com/smallbusiness/credit-cards/products/unlimited-cash-rewards-business-credit-card",
    imageUrl: "/images/bankofamerica/business-advantage-unlimited-cash.webp",
    credits: [],
    offers: [
      {
        amount: [{ amount: 500 }],
        spend: 5000,
        days: 90,
        credits: [],
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 300 }],
        spend: 3000,
        days: 90,
        credits: [],
        expiration: "2026-03-21",
      },
    ],
  },
  {
    cardId: "1e75cf9ca2ccded9a621d5e8f5630c3c",
    name: "Business Advantage Travel Rewards",
    issuer: schemas.IssuersEnum.enum.BANK_OF_AMERICA,
    network: schemas.NetworksEnum.enum.MASTERCARD,
    currency: schemas.CurrenciesEnum.enum.BANK_OF_AMERICA,
    isBusiness: true,
    annualFee: 0,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1.5,
    url: "https://www.bankofamerica.com/smallbusiness/credit-cards/products/travel-rewards-business-credit-card",
    imageUrl: "/images/bankofamerica/business-advantage-travel-rewards.webp",
    credits: [],
    offers: [
      {
        amount: [{ amount: 50_000 }],
        spend: 5000,
        days: 90,
        credits: [],
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 30_000 }],
        spend: 3000,
        days: 90,
        credits: [],
        expiration: "2026-03-21",
      },
    ],
  },
  {
    cardId: "9dce80bda519a8616ca4eb288d7cc693",
    name: "Platinum Plus",
    issuer: schemas.IssuersEnum.enum.BANK_OF_AMERICA,
    network: schemas.NetworksEnum.enum.MASTERCARD,
    currency: schemas.CurrenciesEnum.enum.USD,
    isBusiness: true,
    annualFee: 0,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1.5,
    url: "https://www.bankofamerica.com/smallbusiness/credit-cards/products/platinum-plus-business-credit-card",
    imageUrl: "/images/bankofamerica/platinum-plus.webp",
    credits: [],
    offers: [
      {
        amount: [{ amount: 300 }],
        spend: 3000,
        days: 90,
        credits: [],
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 300 }],
        spend: 1000,
        days: 90,
        credits: [],
      },
    ],
  },
  {
    cardId: "541d121bd20b148d43a8c896d0de6830",
    name: "Free Spirit",
    issuer: schemas.IssuersEnum.enum.BANK_OF_AMERICA,
    network: schemas.NetworksEnum.enum.MASTERCARD,
    currency: schemas.CurrenciesEnum.enum.SPIRIT,
    isBusiness: false,
    annualFee: 79,
    isAnnualFeeWaived: true,
    universalCashbackPercent: 1.5,
    url: "https://www.bankofamerica.com/credit-cards/products/spirit-airlines-credit-card/",
    imageUrl: "/images/bankofamerica/free-spirit.webp",
    credits: [
      {
        value: 100,
        description: "Companion Flight Voucher",
        weight: 0.6,
      },
    ],
    discontinued: true,
    offers: DISCONTINUED_OFFERS,
    historicalOffers: [
      {
        amount: [{ amount: 65_000 }],
        spend: 1000,
        days: 90,
        credits: [
          {
            description: "Companion Flight Voucher",
            value: 100,
            weight: 0.6,
          },
        ],
        expiration: "2025-06-04",
      },
      {
        amount: [{ amount: 50_000 }],
        spend: 1000,
        days: 90,
        credits: [
          {
            description: "Companion Flight Voucher",
            value: 100,
            weight: 0.6,
          },
        ],
      },
      {
        amount: [{ amount: 60_000 }],
        spend: 1000,
        days: 90,
        credits: [],
      },
      {
        amount: [{ amount: 50_000 }],
        spend: 1000,
        days: 90,
        credits: [],
      },
    ],
  },
  {
    cardId: "12a1230229f936ee5f7b2d333e796ab8",
    name: "Atmos Rewards Ascent",
    issuer: schemas.IssuersEnum.enum.BANK_OF_AMERICA,
    network: schemas.NetworksEnum.enum.VISA,
    currency: schemas.CurrenciesEnum.enum.ALASKA,
    isBusiness: false,
    annualFee: 95,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1.0,
    url: "https://www.alaskaair.com/atmosrewards/content/credit-cards",
    imageUrl: "/images/bankofamerica/atmos-rewards-ascent.webp",
    credits: [CREDITS.CHECKED_BAG_MULTIPLE],
    offers: [
      {
        amount: [{ amount: 80_000 }],
        spend: 5000,
        days: 90,
        details:
          "60,000 points after $3,000 in purchases, plus 20,000 after $5,000 total within 90 days.",
        credits: [
          {
            description: "Companion Flight Voucher",
            value: 100,
            weight: 0.6,
          },
        ],
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 70_000 }],
        spend: 2500,
        days: 90,
        credits: [
          { description: "Companion Flight Voucher", value: 100, weight: 0.6 },
        ],
        expiration: "2026-10-31",
      },
      {
        amount: [{ amount: 85_000 }],
        spend: 4000,
        days: 120,
        credits: [
          {
            description: "Companion Flight Voucher",
            value: 100,
            weight: 0.6,
          },
        ],
        expiration: "2026-08-24",
      },
      {
        amount: [{ amount: 80_000 }],
        spend: 4000,
        days: 120,
        credits: [
          {
            description: "Companion Flight Voucher",
            value: 100,
            weight: 0.6,
          },
        ],
        expiration: "2026-04-04",
      },
    ],
  },
  {
    cardId: "2878b32104d7bf242496a8af56f33952",
    name: "Atmos Rewards Summit",
    issuer: schemas.IssuersEnum.enum.BANK_OF_AMERICA,
    network: schemas.NetworksEnum.enum.VISA,
    currency: schemas.CurrenciesEnum.enum.ALASKA,
    isBusiness: false,
    annualFee: 395,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1.0,
    url: "https://www.alaskaair.com/atmosrewards/content/credit-cards",
    imageUrl: "/images/bankofamerica/atmos-rewards-summit.webp",
    credits: [
      CREDITS.CHECKED_BAG_MULTIPLE,
      CREDITS.PRECHECK_OR_SIMILAR,
      {
        description: "Lounge Access",
        value: 300,
        weight: WEIGHTS.LOUNGES,
      },
      {
        description: "Wifi Passes",
        value: 60,
        weight: 0.5,
      },
    ],
    offers: [
      {
        amount: [{ amount: 100_000 }],
        spend: 6000,
        days: 90,
        credits: [
          {
            description: "Companion Award",
            value: 25_000,
            currency: "ALASKA",
            weight: 0.75,
          },
        ],
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 80_000 }],
        spend: 4000,
        days: 90,
        credits: [
          {
            description: "Companion Award",
            value: 2500,
            currency: "ALASKA",
            weight: 0.75,
          },
        ],
        expiration: "2026-10-31",
      },
      {
        amount: [{ amount: 100_000 }],
        spend: 6000,
        days: 90,
        credits: [
          {
            description: "Companion Award",
            value: 2500,
            currency: "ALASKA",
            weight: 0.75,
          },
        ],
        expiration: "2026-06-30",
      },
      {
        amount: [{ amount: 80_000 }],
        spend: 4000,
        days: 90,
        credits: [
          {
            description: "Companion Award",
            value: 2500,
            currency: "ALASKA",
            weight: 0.75,
          },
        ],
        expiration: "2026-04-04",
      },
      {
        amount: [{ amount: 100_000 }],
        spend: 6000,
        days: 90,
        credits: [
          {
            description: "Companion Award",
            value: 2500,
            currency: "ALASKA",
            weight: 0.75,
          },
        ],
        expiration: "2026-03-21",
      },
    ],
  },
  {
    cardId: "9e42d6cf9c6dcfda0cf7d5f5f015285d",
    name: "Atmos Rewards Business",
    issuer: schemas.IssuersEnum.enum.BANK_OF_AMERICA,
    network: schemas.NetworksEnum.enum.VISA,
    currency: schemas.CurrenciesEnum.enum.ALASKA,
    isBusiness: true,
    annualFee: 95,
    isAnnualFeeWaived: false,
    universalCashbackPercent: 1.0,
    url: "https://www.alaskaair.com/atmosrewards/content/credit-cards",
    imageUrl: "/images/bankofamerica/atmos-rewards-ascent.webp",
    credits: [CREDITS.CHECKED_BAG_MULTIPLE],
    offers: [
      {
        amount: [{ amount: 85_000 }],
        spend: 5000,
        days: 90,
        credits: [
          {
            description: "Companion Flight Voucher",
            value: 100,
            weight: 0.6,
          },
        ],
        details: "Requires a 7-digit FA promotional code.",
      },
    ],
    historicalOffers: [
      {
        amount: [{ amount: 80_000 }],
        spend: 5000,
        days: 90,
        credits: [
          {
            description: "Companion Flight Voucher",
            value: 100,
            weight: 0.6,
          },
        ],
      },
    ],
  },
];
